/**
 * GlobalUserPill — top-right Sign-in / Profile slot mounted on every route
 * via the RootLayout.
 *
 * Background: prior to this, UserPill lived on /play (inside the canvas
 * toolbar) and on / (absolute-positioned on HomePage). Every other route —
 * /leaderboard, /pricing, /account, /leagues, /terms, /privacy, /refund,
 * /admin, /c/:attemptId — had no visible sign-in entry. The only path back
 * to sign-in from those pages was "go to Today's kick" then sign in there.
 *
 * Now UserPill is rendered in a `fixed top-3 right-3 z-30` slot from
 * RootLayout on every route. Two exceptions:
 *
 *   1. /play already has a banner header occupying the top space, plus
 *      an embedded UserPill inside the canvas action toolbar. We suppress
 *      the global pill there to avoid two pills + banner overlap.
 *   2. /admin uses its own page chrome with `right-aligned` nav pills; the
 *      global pill sits comfortably to the right of them at top-3.
 *
 * z-30 was chosen so the pill sits above page content (z-10) and tutorial
 * overlays (z-20) but below modal dialogs (z-50) opened from the pill
 * itself (SignInModal, ProfileModal).
 */
import { useLocation } from "react-router-dom";
import { UserPill } from "@/components/UserPill";

const SUPPRESSED_PATHS = new Set<string>([
  "/play",
]);

export function GlobalUserPill() {
  const { pathname } = useLocation();
  if (SUPPRESSED_PATHS.has(pathname)) return null;
  return (
    <div className="fixed right-3 top-3 z-30">
      <UserPill />
    </div>
  );
}
